import React from 'react';

import StandardsList from '../StandardsList';
import { TABS } from '../StandardsSelector';

const ReviewContainer = ({ categorizedStandards, setSelectedStandards, setAppliedStandards }) => {
  return (
    <StandardsList activeTab={TABS.REVIEW} standards={categorizedStandards} categorizedStandards={categorizedStandards} setSelectedStandards={setSelectedStandards} setAppliedStandards={setAppliedStandards} />
  );
};

export default ReviewContainer;
